module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("1")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Detecting"), _c('br'), _vm._v("the Deceiver")])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_c('span', {
    staticClass: "r"
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("  2 Corinthians 11:1-15  ")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the movie "), _c('i', [_vm._v("Jurassic Park")]), _vm._v(", Dr. Allen Grant and his team are digging for dinosaurs in the Badlands, near Snakewater, Montana. They set off a seismic charge, and the image of an ancient skeleton appears on the video screen. It’s a velociraptor—one of the most cunning and deadly predators ever to walk the earth. But a young boy visiting the site isn’t impressed. He says, “That doesn’t look very scary—more like a six-foot turkey.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Dr. Grant responds by describing how a velociraptor goes about an attack: “You stare at him, and he just stares right back. And that’s when the attack comes—not from the front but from the "), _c('i', [_vm._v("side")]), _vm._v(", from the other two raptors you didn’t even know were there.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In spiritual warfare the most dangerous attacks come unexpectedly. Christians often focus their attention on spiritual enemies that are obvious and plainly visible. While our attention is focused on these obvious forms of evil, suddenly the most lethal attacks come from the sides, from satanic influences we didn’t even know were there. In other words, the greatest threats to our faith, our families and our church do not come from the demonic influences we "), _c('i', [_vm._v("can")]), _vm._v(" see but from those that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("we "), _c('i', [_vm._v("cannot")]), _vm._v(" see—the ones that are so cunning that they are virtually invisible.")])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROUP")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCUSSION")]), _vm._v(". What are some examples of the plainly visible evil we tend to focus on?")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Why do we focus on these things?")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSONAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFLECTION")]), _vm._v(". What invisible enemies have you struggled with in the past?")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We cannot fight an enemy we cannot see. So in this passage we will look at some of the disguises Satan wears, so that we can see behind his masks. We will look at some of the deceitful practices he uses, so that we won’t be fooled. "), _c('i', [_vm._v("Read 2 Corinthians 11:1-15")]), _vm._v(".")]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" In this passage how does Paul compare himself to and contrast himself with the “false apostles” in Corinth (vv. 1-15)?")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" How are the dangers the Corinthians faced similar to those Eve faced when she first met the serpent (vv. 1-3)?")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Why is it more effective for deceivers to distort the gospel than to deny "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("it altogether, or to preach a different Jesus rather than no Jesus at all (v. 4)?")])])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Evidently, false apostles had infiltrated the Corinthian church. In what ways did these “super-apostles” seem far superior to Paul (vv. 5-12; see also 10:1, 10)?")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("5.")]), _vm._v(" How does biblical knowledge (v. 6) protect you from eloquent speakers who are trying to deceive you?")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("6.")]), _vm._v(" In contrast to the false apostles, Paul didn’t charge people for his ministry (vv. 7-12). Why do you think the Corinthians viewed this practice as a weakness rather than a strength?")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("How does Paul defend himself in this matter?")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("7.")]), _vm._v(" How can we discern the difference between those who preach merely for money and prestige and those who have godly motives?")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("8.")]), _vm._v(" Why do you think Satan masquerades as an angel of light rather than appearing as a demon of darkness (v. 14)?")])]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("9.")]), _vm._v(" Why might Satan’s servants also find it effective to masquerade as “ministers of righteousness” (v. 15)?")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("10.")]), _vm._v(" What are some of the pious disguises that Satan’s servants use to deceive people today?")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("11.")]), _vm._v(" Throughout history the Christian “army” has been notorious for shooting its own soldiers. As we seek to unmask deceivers in our midst, how can we keep from falsely accusing true servants of righteousness?")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("12.")]), _vm._v(" Paul concludes this passage by saying, “Their end will be what their actions deserve.” What types of actions might reveal that a “minister of righteousness” is really working for the enemy?")])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Ask God to give you the biblical wisdom and spiritual discernment you need to see behind Satan’s many disguises")]), _vm._v(".")]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Now or Later")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This week visit your local Christian bookstore and ask for help in selecting a book on cults and new religions. As you read the book, look for ways these groups present a distorted picture of Jesus, the Holy Spirit and the gospel. Also notice some of the pious disguises they use to hide their true nature.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 66
// module chunks = 0